<template>
    <div class="preparescjpage padding-b-x">
        <a href="" class="downloadFile"></a>
        <div class="padding-y">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item >备课中心详情页</el-breadcrumb-item>
                <el-breadcrumb-item>备课中心收藏页</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="containWrap d-flex justify-content">
            <div class="left-catalog public_scroll_bar" v-loading="loadingCollection">
                <div class="tree-con d-flex alignCenter"
                     :class="selectDirectoryId===item.id?'directoryActive':''" @click="selectDirectoryTap(item.id)"
                     v-for="item in getLeftCollectionData" :key="item.id">
                                <span class="text-ellipsis alignCenter d-flex">
                                    <span class="el-icon-document"></span>
                                    <span>{{item.name}}</span>
                                </span>
                    <div class="tree-btns display-b-i"  v-show="!item.isSys">
                        <el-button type="text" @click="changeNameDialog(item.id,item.name)">重命名</el-button>
                        <el-button type="text" @click="delCollection(item.id)" class="text-danger">删除</el-button>
                    </div>
                </div>
            </div>
            <div class="right-catalog" v-loading="loadingRightContent" >
                <div v-show="getCollectionContentList.length>0">
                    <div class="cardContent padding-b public_scroll_bar">
                        <div class="padding alignCenter d-flex justify-content" v-for="item in getCollectionContentList" :key="item.id">
<!--                            <div></div>-->
                            <div class="title">
                                <div class="titleName">
                                    {{item.courseWareName}}
                                </div>
                                <div class="titleDescribe">
                                    <span>更新日期：{{item.updatedAt}}</span>
                                    <span>浏览次数：{{item.views}}</span>
                                    <span>下载次数：{{item.downLoads}}</span>
                                </div>
                            </div>
                            <div>
                                <el-button type="text" @click="cancelCollection(item.id)">取消收藏</el-button>
                                <el-button type="text" @click="dowloadKjZy(item.courseWareId,item.courseWareName)">下载</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="text-right margin-top">
                        <el-pagination
                                       layout="total, prev, pager, next, jumper"
                                       :page-size="5"
                                       :total="totalItem"
                                       :current-page.sync="currentPage"
                                       @current-change="handlerPage">
                        </el-pagination>
                    </div>
                </div>
                <div v-show="getCollectionContentList<1">
                    <empty ></empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {cancelFavCourseWare, courseWareFavCategory, downloadCoursWare, userCourseWareFavList} from "../../config";
    import {message} from 'element-ui'
    export default {
        name: "preparescjpage",
        data(){
            return{
                //获取左侧收藏夹列表
                getLeftCollectionData:[],
                //设置收藏夹的加载项
                loadingCollection:true,
                //设置右侧内容的加载项
                loadingRightContent:true,
                //获取当前所选择的目录
                selectDirectoryId:'',
                currentPage:1,
                totalItem:1,
                //获取收藏夹中的内容
                getCollectionContentList:[]
            }
        },
        mounted(){
          this.getLeftCollection();
        },
        methods:{
            async dowloadKjZy(val,valName){
                let result=await downloadCoursWare(val);
                if(result.status){
                    //执行下载
                    window.open(window.atob(result.data));
                }else{

                }
            },
            async cancelCollection(val){
                let result=await cancelFavCourseWare(val);
                if(result.status){
                    this.getRightContent();
                    message({
                        message:'取消成功',
                        type:'success',
                        offset:200
                    })
                }else{

                }
            },
            selectDirectoryTap(val){
              this.selectDirectoryId=val;
              this.getRightContent();
            },
            handlerPage(){

            },
            //获取左侧收藏夹
            async getLeftCollection(){
                this.loadingCollection=true;
                let result=await courseWareFavCategory();
                if(result.status){
                    this.loadingCollection=false;
                    this.getLeftCollectionData=result.data;
                    this.selectDirectoryId=result.data[0].id;
                    this.getRightContent();
                }else{
                    this.loadingCollection=false;
                }
            },
            //获取右侧根据收藏夹查出相关收藏夹下的课件内容
            async getRightContent(){
                this.loadingRightContent=true;
                let result=await userCourseWareFavList(this.selectDirectoryId,this.currentPage,5);
                if(result.status){
                    this.loadingRightContent=false;
                    this.getCollectionContentList=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }else{
                    this.loadingRightContent=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../assets/static/commonStyle/commonStyle";
    .preparescjpage{

        .containWrap{
            .left-catalog{
                padding-top: 20px;
                width: 300px;
                height: 600px;
                background-color: #fff;
                padding-left: 10px;
                -webkit-box-shadow: 0 0 6px 0 rgb(0 0 0 / 10%);
                box-shadow: 0 0 6px 0 rgb(0 0 0 / 10%);
                border-radius: 6px;
                .tree-con{
                    position: relative;
                    height: 28px;cursor: pointer;
                    >span{
                        padding-left: 2px;
                        max-width: 220px;
                        .el-icon-document{
                            width: 10px;vertical-align: middle;border-style: none;
                        }
                        :nth-of-type(2){
                            margin-left: 15px;
                        }
                    }
                    .tree-btns{
                        position: absolute;
                        right: 0;
                        margin: 0 8px 0 18px;
                    }
                }
            }
            .right-catalog{
                position: relative;
                width: calc(100% - 320px);
                .padding{
                    border-bottom: 1px solid #e5e5e5;
                }
                .cardContent{
                    height:540px;
                    background: #ffffff;
                    border: 0 solid #e8e8e8;
                    border-radius: 4px;
                    -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
                    box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
                    .title{
                        .titleName{
                            margin-top: 0;
                            margin-bottom: .5em;
                            color: rgba(0,0,0,.85);
                            font-weight: 500;
                            font-size: 20px;
                        }
                        .titleDescribe{
                            span{
                                margin-right: 10px;
                                color:#888;
                            }
                        }
                    }
                }
            }
    }
    }
</style>